exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.ticket-generate-report .v-stepper__label {\n  font-weight: 700 !important;\n  font-size: 18px !important;\n  font-style: normal;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/ticket/components/ticket-modal-generate-intervention-report/TicketModalGenerateInterventionReport.vue"],"names":[],"mappings":";AAIA;EAEI,4BAA2B;EAC3B,2BAA0B;EAC1B,mBAAkB;CACnB","file":"TicketModalGenerateInterventionReport.vue","sourcesContent":["\n\n\n\n.ticket-generate-report {\n  .v-stepper__label {\n    font-weight: 700 !important;\n    font-size: 18px !important;\n    font-style: normal;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-516963cf","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1&bustCache!./src/containers/ticket/components/ticket-modal-generate-intervention-report/TicketModalGenerateInterventionReport.vue
// module id = DmEW
// module chunks = 0